module.exports = __webpack_public_path__ + "static/stray-a75d218cbf53b781eb6392bd55b94a9a.jpg";